module.exports = __webpack_public_path__ + "img/united-kingdom.9d9a6874.png";